/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Grid,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Checkbox,
  Tabs,
  Tab,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { getConfiguration, getDocumentData, getDocumentResources } from '../../../store/slices/account-entries/thunks';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { DocumentData, resetDocumentData } from '../../../store/slices/account-entries';
import { AccountingEntriesDataGrid } from '../../../components/AccountingEntriesDataGrid';
import { Scenarios } from '../../../constants/scenarios';


interface InvoiceModalProps {
  open: boolean;
  onClose: () => void;
  selectedRow: any;
}

interface HeaderFieldConfig {
  label: string;
  field?: keyof DocumentData;
  span?: number;
  boolean?: boolean;
}

const HEADER_FIELDS: HeaderFieldConfig[] = [
  { label: 'Sucursal', field: 'DesSucursal' },
  { label: 'Correlativo', field: 'NumeroCorrelativo' },
  { label: 'N°', field: 'NumeroDocumento' },

  { label: 'Emite', field: 'DesEmpresa' },
  { label: 'Cliente', field: 'SocioNegocio' },


  { label: 'Fecha', field: 'FechaDocumento' },
  { label: 'Fecha Vencimiento', field: 'FechaVencimiento' },
  { label: 'Fecha Recepción', field: 'FechaRecepcion' },
  { label: 'Enviado a', field: 'EmailEnviado' },
  { label: 'Período de aplicación', field: 'DesPeriodoContable' },
  { label: 'Tipo de cambio (no oficial)', field: 'TipoCambio', boolean: true },
  { label: 'Moneda', field: 'DesMoneda' },
  { label: 'Forma de pago', field: 'DesFormaPago' },
  { label: 'Relacionado Con', field: 'RelacionadoCon' },
  { label: 'Proyecto', field: 'DesProyecto', span: 6 },
  { label: 'Concepto u Observación', field: 'Observacion', span: 6 },


];

interface FooterLeftFieldConfig {
  label: string;
  field?: keyof DocumentData;
}

const FOOTER_LEFT_FIELDS: FooterLeftFieldConfig[] = [
  { label: 'Registrado por', field: 'CreacionUsuario' },
  { label: 'Autorizado por', field: 'AprobacionUsuario' },
  { label: 'Revisados por', field: 'RevisionUsuario' },

  
  { label: 'Código detracción', field: 'NroDetraccion' },
  { label: 'Constancia de detracción', field: 'NumeroConstanciaDetraccion' },
  { label: 'Fecha de detracción', field: 'FechaConstanciaDetraccion' },
];

interface FooterTotalFieldConfig {
  label: string;
  field?: keyof DocumentData;
  isBold?: boolean;
}

const FOOTER_TOTAL_FIELDS: FooterTotalFieldConfig[] = [
  { label: 'Neto Facturado', field: 'TotalNeto' },
  { label: 'I.G.V', field: 'ValorIGV' },
  { label: 'Total', field: 'Total', isBold: true },
  { label: 'Detracción', field: 'MontoDetraccion' },
];

interface DetailFieldConfig {
  label: string;
  field?: keyof DocumentData;
  span?: number;
  boolean?: boolean;
}

const DETAILS_FIELDS: DetailFieldConfig[] = [
  { label: 'Aplica Percepción', field: 'GeneraComprobantePercepcion', boolean: true },
  { label: 'Aplica Detracción', boolean: true },
  { label: 'No aplicar Retención', field: 'NoAplicaRetencion', boolean: true },
  { label: 'Serie Alfanumérica', boolean: true },
  { label: 'N O.C.', boolean: true },
  { label: 'No aplicar Retención', field: 'NoAplicaRetencion', boolean: true },
  { label: 'Percepción por Documento', field: 'NroPercepcion', boolean: true },
  { label: 'Aduana', field: 'DesAduana'},
  { label: 'Estado', field: 'Estado' },
  { label: 'Liquidación', field: 'MontoLiquidacion' },
  { label: 'Tipo Boleto', field: 'TipoBoleto' },
  { label: 'Centro de Costo', field: 'DesCentroDeCosto' },
  { label: 'Tipo Boleto', field: 'TipoBoleto' },
  { label: 'Aprobado', field: 'Aprobado', boolean: true },
  { label: 'Serie Máquina Registradora', field: 'SerieMaquinaRegistradora' },
  { label: 'Tipo Nomina', field: 'DocumentoNomina' },
  { label: 'Tipo Boleta', field: 'TipoBoletajeSperant' },
  { label: 'Prioridad de Pago', field: 'PrioridadPago', boolean: true },

]

const DETALLE_FIELDS: (keyof DocumentData)[] = [
  'NaturalJuridicaSocioNegocio',
  'DNISocioNegocio',
  'RUCSocioNegocio',
  'RUCEmpresa',
  'Simbolo',
  'CodMotivoPago',
  'DesMotivoPago',
  'CodMetodoPago',
  'DesMetodoPago',
  'CodTipoNotaCreditoDebito',
  'DesTipoNotaCreditoDebito',
  'CodTipoRenta',
  'DesTipoRenta',
  'CodCentroDeCosto',
  'NroD',
  'CodDocumento',
  'CodTipoDocumento',
  'SerieDocumento',
  'CodIdentificador',
  'CodMoneda',
  'CodFormaDePago',
  'TipoCambioEspecial',
  'TipoCambioDia',
  'Descuento',
  'ImpuestoRenta',
  'ImpuestoSolidaridad',
  'TotalAfecto',
  'TotalInafecto',
  'CodIdentificadorDestino',
  'NroGuia',
  'Calculado',
  'NetoOrigen',
  'IGVOrigen',
  'TotalOrigen',
  'NroDoc',
  'Retenido',
  'TipoDocumentoRelacionado',
  'AfectoImpuesto',
  'Poliza',
  'FechaVigenciaDel',
  'FechaVigenciaAl',
  'Asignado',
  'CodProyecto',
  'NroCentroDeCosto',
  'Enviado',
  'NroVoucher',
  'CreacionFecha',
  'ActualizacionUsuario',
  'ActualizacionFecha',
  'NroMotivoPago',
  'NroMetodoPago',
  'NoEnviar',
  'NroRegularizacion',
  'EsRegularizacion',
  'NroAutor',
  'Log',
  'Operacion',
  'LogFecha',
  'LogUsuario',
  'NroEnvio',
  'CodProyectoPago',
  'CodPago',
  'Procedencia',
  'Afecto1',
  'Inafecto1',
  'Neto1',
  'Impuesto1',
  'Total1',
  'Afecto2',
  'Inafecto2',
  'Neto2',
  'Impuesto2',
  'Total2',
  'MontoNeto',
  'AfectaRetencion',
  'PorcentajeRetencion',
  'MontoRetencion',
  'ImpresionFecha',
  'NumeroComprobanteGalac',
  'NroPeriodoContable',
  'AplicaLibroCompraVenta',
  'CodSucursal',
  'NetoOrigen1',
  'IgvOrigen1',
  'TotalOrigen1',
  'NetoOrigen2',
  'IgvOrigen2',
  'TotalOrigen2',
  'NroTalonarioDetalle',
  'MontoDetraccion1',
  'MontoDetraccion2',
  'AplicaGestion',
  'BankAccount_ID_Origen',
  'BankAccount_ID_Destino',
  'AsignadoNotaVenta',
  'NroGuiaDoc',
  'FechaAplicacionContable',
  'EsServicio',
  'RevisionFecha',
  'TieneNota',
  'ValorReferencial',
  'PorcentajePercepcion',
  'MontoPercepcion',
  'PorcentajeDetraccion',
  'DctoRelacionado',
  'OCRelacionado',
  'TotalPagado',
  'TotalSaldo',
  'Ano',
  'AnoMes',
  'NroNVPagoDetalle',
  'MontoLiquidacion',
  'RetencionCobranza',
  'NroDocumentoPago',
  'AFPAporte',
  'AFPComision',
  'AFPSeguro',
  'EsperaPercepcion',
  'ONPAporte',
  'PercepcionPorDocumento',
  'Autodetraccion',
  'SinRevisionUsuario',
  'SinRevisionFecha',
  'FactorVenta',
  'NroAduana',
  'Pago_ID',
  'C_PaySelectionLine_ID',
  'AfectaPercepcion',
  'AfectaDetraccionManual',
  'NroTipoNotaCreditoDebito',


  'HonorarioLibroCompra',
  'CodProveedorExterior',
  'SerieDocumentoExterior',
  'NumeroDocumentoExterior',
  'FechaDocumentoExterior',
  'NroTipoDeRenta',
  'NroPeriodoContableRectificacion',
  'TotalISC',
  'AprobacionFecha',
  'NroPeriodoContableLibro',
  'CodADAnticipo',
  'NumeroGrupoAnticipo',
  'FechaAbono',
  'TipoProcDocumento',
  'InafectoExonerado1',
  'InafectoExonerado2',
  'Exonerado1',
  'Exonerado2',
  'EnviadoPortalProveedor',
  'FechaEnviadoPortalProveedor',
  'DetraccionPagoNotaCredito',
  'NumeroOC',
  'NoAplicaRetencion',
  'NetoGravada1',
  'ImpuestoGravada1',
  'TotalGravada1',
  'NetoNoGravada1',
  'ImpuestoNoGravada1',
  'TotalNoGravada1',
  'NetoAmbosGravada1',
  'ImpuestoAmbosGravada1',
  'TotalAmbosGravada1',
  'OtrosImpuestos1',
  'CalculaParcialUsuario',
  'CalculaParcialFecha',
  'HoraEmision',
  'Provision',
  'OtrosConceptos1',
  'OtrosConceptos2',
  'OID',
  'DesEstadoPeriodo',
  'FormaConstanciaDetraccion',
  'CodEstadoFinal',
  'EstadoAprobacion',
  'ObservacionAprobacion',
  'ADRelacionado',
  'EstadoElectronico',
  'EnviadoPortal',
  'FormaCorrelativo',
  'CodTipoDocumentoOrigen',
  'FormaConstanciaDetraccion1',
  'CorrelativoUsuario',
  'CorrelativoFecha',
  'ClasificacionBienes',
  'DocumentoAsociado',
  'Origen',
  'NetoDeducible1',
  'ImpuestoDeducible1',
  'TotalDeducible1',
  'CodIdentificadorOrigen',
  'NumeroCorrelativoInicial',
  'DesDimension01',
  'DesDimension02',
  'DesDimension03',
  'DesDimension04',
  'DesDimension05',
  'DesDimension06',
  'DesDimension07',
  'DesDimension08',
  'DesDimension09',
  'DesDimension10',
  'Prioridad',
  'ModoRegistro',
  'ValidacionUsuario',
  'ValidacionFecha',
  'Validado',
  'ValidacionObservacion',
  'Ticket',
  'TotalNetoNC',
  'TotalImpuestoNC',
  'TotalNC',
  'CodProyectoRelacionado',
  'NroGrupoAprobacion',
  'NumeroAprobadores',
  'UsuarioA',
  'FechaEnvioAprobacion',
  'NroPC',
  'CodFormato',
  'CodTipoDocumentoSunat',
  'CodFormatoSunat',
];

const getFieldValue = (doc: DocumentData, field?: keyof DocumentData, isBoolean?: boolean): any => {
  if (!field || !doc) return 'X';
  const v = (doc as any)[field];
  if (isBoolean) return [1, true, 'true'].includes(v) ? 'Sí' : [0, '0', false].includes(v) ? 'No' : '-';
  return v === undefined || v === null || v === '' ? '-' : v;
};

const displayValue = (v: any): string => {
  if (v === null || v === undefined || v === '') return '-';
  if (typeof v === 'boolean') return v ? 'Sí' : 'No';
  return String(v);
};

export const InvoiceModal: React.FC<InvoiceModalProps> = ({ open, onClose, selectedRow }) => {

  const dispatch = useDispatch();
  const scenario = Scenarios.DocumentDetail;
  const {documentData, documentResources} = useSelector((state: RootState) => state.accountEntries);
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    if (!open || !selectedRow?.NroD) {
      return
    };
    dispatch(resetDocumentData());
    getDocumentData(selectedRow.NroD);
  }, [open, selectedRow]);

  useEffect(() => {
    if (!documentData?.CodTipoDocumento) return;
    const sufix = `${documentData.CodFormatoSunat}${documentData.Procedencia && documentData.CodFormato === '01' ? '-1' : ''}`;
    getConfiguration(scenario, sufix);
  }, [documentData?.CodTipoDocumento, selectedRow?.NroD]);


  useEffect(() => {
    if (!documentData?.CodTipoDocumento) return;
    getDocumentData(selectedRow.NroD);
    getDocumentResources(selectedRow.NroD, documentData.CodTipoDocumento, documentData.CodTipoDocumentoSunat);
  }, [documentData?.CodTipoDocumento, selectedRow?.NroD]);
  
  const LabelValue: React.FC<{ label: string; value: any, oneRow?: boolean }> = (
    { label, value, oneRow }
  ) => (
    <Box 
      sx={
        oneRow
        ? { display: 'flex', justifyContent: 'left', alignItems: 'center'}
        : { mb: 1 }
      }
    >
      <Typography 
        variant="caption" 
        color="textSecondary" 
        sx={{ fontWeight: 600, marginRight: oneRow ? '10px' : '0px' }}
      >
        {label}: {" "}
      </Typography>
      <Typography variant="body2">
        {displayValue(value)}
      </Typography>
    </Box>
  );

  const TotalRow: React.FC<{ label: string; value: any; isBold?: boolean }> = ({ label, value, isBold }) => (
    <TableRow
      sx={{
        '&:nth-of-type(odd)': { backgroundColor: '#f5f5f5' },
        '&:last-child td': { borderBottom: 0 },
      }}
    >
      <TableCell sx={{ fontWeight: isBold ? 600 : 400 }}>{label}</TableCell>
      <TableCell align="right" sx={{ fontWeight: isBold ? 600 : 400 }}>
        {typeof value === 'number' && !isNaN(value) ? value.toFixed(2) : displayValue(value)}
      </TableCell>
    </TableRow>
  );

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 1,
          height: 'auto',
          maxHeight: '95vh',
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          pb: 1,
          flexShrink: 0,
        }}
      >
        <span>{`RUC ${getFieldValue(documentData, 'RUCSocioNegocio')} - ${getFieldValue(documentData, 'SerieDocumento')}-${getFieldValue(documentData, 'NumeroDocumento')}`}</span>
        <Button onClick={onClose} size="small" sx={{ minWidth: 'auto', p: 0.5 }}>
          <CloseIcon fontSize="small" />
        </Button>
      </DialogTitle>

      <DialogContent dividers sx={{ flex: 1, overflow: 'auto', p: 2 }}>
        <Box sx={{ mb: 1 }}>
          <Grid container spacing={0}>
            {HEADER_FIELDS.map(item => (
              <Grid item xs={12} sm={item.span || 3} key={item.label}>
                <LabelValue label={item.label} value={getFieldValue(documentData, item.field, item.boolean)} />
              </Grid>
            ))}
          </Grid>
        </Box>

        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 1 }}>
          <Tabs value={activeTab} onChange={(_e, newValue) => setActiveTab(newValue)} aria-label="detalle factura">
            <Tab label="Items" />
            <Tab label="Información" />
          </Tabs>
        </Box>

        {activeTab === 0 && (
        <Box sx={{ width: '100%', mb: 0, overflow: 'auto' }}>
          <AccountingEntriesDataGrid
            operationMode="local"
            scenario={scenario}
            data={documentResources || []}
            isConfigAvailable={true}
            isGroupingAvailable={true}
            isFilterPanelAvailable={false}
          />
        </Box>
        )}

        {activeTab === 1 && (
          <Box sx={{ width: '100%' }}>
            <Grid container spacing={1}>
              {DETAILS_FIELDS.map(item => (
                <Grid item xs={12} sm={item.span || 3} key={item.label}>
                  <LabelValue label={item.label} value={getFieldValue(documentData, item.field, item.boolean)} />
                </Grid>
              ))}
              {/* {DETALLE_FIELDS.map(field => (
                <Grid item xs={12} sm={6} md={4} key={field}>
                  <LabelValue label={field} value={getFieldValue(documentData, field)} />
                </Grid>
              ))} */}
            </Grid>
          </Box>
        )}

        <Grid container spacing={2}>
          <Grid item xs={12} sm={7}>
            <Box>
              {FOOTER_LEFT_FIELDS.map(item => (
                <LabelValue key={item.label} label={item.label} value={getFieldValue(documentData, item.field)} oneRow={true} />
              ))}
              <Box sx={{ display: 'flex', justifyContent: 'left', alignItems: 'center'}}>
                <Checkbox checked={getFieldValue(documentData, 'Impreso') === true} disabled size="small" sx={{padding: 0}} />
                <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 600, ml: 1 }}>
                  Impreso por: {displayValue(getFieldValue(documentData, 'ImpresionUsuario'))}
                </Typography>
              </Box>
            </Box>
          </Grid>

          <Grid item xs={12} sm={5}>
            <TableContainer component={Paper} variant="outlined">
              <Table size="small">
                <TableBody>
                  {FOOTER_TOTAL_FIELDS.map(item => (
                    <TotalRow key={item.label} label={item.label} value={getFieldValue(documentData, item.field)} isBold={item.isBold} />
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions sx={{ p: 2, flexShrink: 0 }}>
        <Button onClick={onClose} variant="contained" color="primary">
          Cerrar
        </Button>
      </DialogActions>

    </Dialog>
  );
};